import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

const STEPS = [
  ["Pedido", "Envie o formulário ou chame no WhatsApp contando o tipo de serviço, a região e o que você precisa."],
  ["Avaliação", "Analisamos tamanho, tarefas e frequência. Quando necessário, agendamos uma visita técnica."],
  ["Proposta", "Você recebe um orçamento personalizado com escopo, horários e condições definidos."],
  ["Atendimento", "A limpeza acontece nos dias e horários combinados, de forma avulsa ou recorrente."],
];

export const Process = () => (
  <section id="como-funciona" data-testid="section-como-funciona" className="relative bg-[#121518] text-[#FAF8F5] py-24 md:py-36 overflow-hidden grain">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-14">
      <Reveal className="lg:col-span-4">
        <p className="font-mono-d text-[11px] tracking-[0.3em] text-[#C59B27] mb-5">COMO FUNCIONA</p>
        <h2 className="font-serif-d text-5xl md:text-6xl font-medium leading-[0.95] tracking-tight">
          Do pedido à <em className="text-[#C59B27]">limpeza</em>, em quatro passos.
        </h2>
        <div className="mt-10 relative aspect-[4/5] overflow-hidden rounded-t-full hidden lg:block">
          <img src="/img/mesa-luvas.jpg" alt="Limpeza de mesa de escritório" className="absolute inset-0 w-full h-full object-cover" />
        </div>
      </Reveal>
      <div className="lg:col-span-7 lg:col-start-6">
        {STEPS.map(([t, d], i) => (
          <motion.div key={t} data-testid={`step-${i + 1}`}
            initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className="group grid grid-cols-[auto_1fr] gap-6 md:gap-10 py-8 md:py-10 border-t border-[#FAF8F5]/15 last:border-b">
            <span className="font-mono-d text-sm text-[#C59B27] pt-3">0{i + 1}</span>
            <div>
              <h3 className="font-serif-d text-4xl md:text-5xl transition-transform duration-500 group-hover:translate-x-3">{t}</h3>
              <p className="mt-3 text-[#FAF8F5]/75 max-w-lg">{d}</p>
            </div>
          </motion.div>
        ))}
        <div className="mt-10 relative aspect-[16/10] overflow-hidden lg:hidden">
          <img src="/img/mesa-luvas.jpg" alt="Limpeza de mesa de escritório" className="absolute inset-0 w-full h-full object-cover" />
        </div>
      </div>
    </div>
  </section>
);
